// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { StatusChip } from '@/components/status-chip';
import {
  InvoiceStatus,
  getInvoiceStatusChipProps,
} from '@/constants/invoice-status';
import { Tooltip } from '@mui/material';

interface Props {
  status: InvoiceStatus;
  /**
   * When the invoice is voided, the reason recorded at void time. Shown as
   * the chip tooltip so users can hover the VOID chip anywhere it appears
   * and see why the invoice was voided. Ignored for non-VOID statuses.
   */
  voidReason?: string | null;
}

export function InvoiceStatusChip(props: Props) {
  const chipProps = getInvoiceStatusChipProps(props.status);
  // VOID gets a tooltip carrying the void reason so hover reveals context
  // anywhere the chip shows; the chip itself keeps its existing outlined-
  // red style.
  if (props.status === 'VOID') {
    const tooltipTitle = props.voidReason?.trim()
      ? props.voidReason
      : 'This invoice was voided';
    return (
      <Tooltip arrow title={tooltipTitle}>
        <span>
          <StatusChip {...chipProps} />
        </span>
      </Tooltip>
    );
  }
  return <StatusChip {...chipProps} />;
}
